export default __webpack_public_path__ + "static/media/iconselected.e4ff2d2f.svg";